var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    {
      staticClass: "chat-sidebar",
      class: {
        "chat-sidebar--recolhida": _vm.recolhida,
        "chat-sidebar--animando": _vm.animandoLargura,
        "chat-sidebar--navegacao": _vm.comoNavegacao,
        "chat-sidebar--trocando-modo": _vm.trocandoModo
      }
    },
    [
      _vm.comoNavegacao
        ? _c("div", { staticClass: "chat-sidebar__barra" }, [
            _vm.mostraMarca
              ? _c("div", { staticClass: "chat-sidebar__marca" }, [
                  _vm.marcaVisivel
                    ? _c("img", {
                        staticClass: "chat-sidebar__marca-img",
                        attrs: {
                          src: _vm.marcaVisivel,
                          alt: _vm.nomeEscritorio
                        },
                        on: { error: _vm.aoFalharMarca }
                      })
                    : _c(
                        "span",
                        {
                          staticClass:
                            "chat-sidebar__marca-inicial ia-texto-micro"
                        },
                        [_vm._v(" " + _vm._s(_vm.inicialEscritorio) + " ")]
                      )
                ])
              : _vm._e(),
            _c("div", { staticClass: "chat-sidebar__acoes-topo" }, [
              _vm.mostraBuscaGlobal
                ? _c(
                    "button",
                    {
                      staticClass: "chat-sidebar__botao-topo",
                      attrs: {
                        type: "button",
                        "data-test": "busca-global-topo",
                        title: _vm.rotuloBuscaGlobal,
                        "aria-label": _vm.rotuloBuscaGlobal
                      },
                      on: { click: _vm.abrirBuscaGlobal }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "search",
                          size: _vm.tamanhoIcone,
                          color: _vm.corIcone
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.personalizacaoDisponivel
                ? _c(
                    "button",
                    {
                      staticClass: "chat-sidebar__botao-topo",
                      attrs: {
                        type: "button",
                        "data-test": "personalizar-painel-topo",
                        title: _vm.texto.personalizarPainel,
                        "aria-label": _vm.texto.personalizarPainel
                      },
                      on: { click: _vm.alternarPersonalizacaoComFade }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "tune",
                          size: _vm.tamanhoIcone,
                          color: _vm.corIcone
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass:
                    "chat-sidebar__botao-topo chat-sidebar__botao-topo--nova",
                  attrs: {
                    type: "button",
                    "data-test": "nova-conversa-topo",
                    title: _vm.rotuloNovaConversa,
                    "aria-label": _vm.rotuloNovaConversa
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("new-conversation")
                    }
                  }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "add-circle",
                      size: _vm.tamanhoIcone,
                      color: _vm.corIcone
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm.modoPersonalizacao && !_vm.recolhida
        ? _c("PersonalizacaoPaleta", {
            staticClass: "chat-sidebar__personalizacao-paleta",
            attrs: { itens: _vm.personalizacaoDraftOcultos },
            on: { adicionar: _vm.aoAdicionarAoRascunho }
          })
        : _vm._e(),
      _c(
        "div",
        {
          ref: "corpo",
          staticClass: "chat-sidebar__corpo",
          class: {
            "chat-sidebar__corpo--personalizando": _vm.modoPersonalizacao
          },
          on: { scroll: _vm.aoRolar }
        },
        [
          _vm.temAtalhos
            ? _c(
                "nav",
                { staticClass: "chat-sidebar__atalhos" },
                [
                  _c("span", {
                    staticClass: "chat-sidebar__atalhos-divisa",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._l(_vm.atalhos, function(atalho) {
                    return _c(
                      "button",
                      {
                        key: atalho.moduleKey,
                        staticClass: "chat-sidebar__botao-topo",
                        attrs: {
                          type: "button",
                          title: atalho.rotulo,
                          "aria-label": atalho.rotulo
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("abrir-insight", atalho)
                          }
                        }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: atalho.icone,
                            size: _vm.tamanhoIcone,
                            color: _vm.corIcone
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c("span", {
                    staticClass: "chat-sidebar__atalhos-divisa",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "chat-sidebar__botao-topo",
                      attrs: {
                        type: "button",
                        title: _vm.texto.verHistorico,
                        "aria-label": _vm.texto.verHistorico
                      },
                      on: { click: _vm.abrirHistorico }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "clock",
                          size: _vm.tamanhoIcone,
                          color: _vm.corIcone
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e(),
          _vm.temNavItems
            ? _c(
                "nav",
                { staticClass: "chat-sidebar__nav" },
                _vm._l(_vm.navItems, function(item) {
                  return _c(
                    "button",
                    {
                      key: item.id,
                      staticClass: "ia-sidebar-row",
                      attrs: { type: "button", title: item.label },
                      on: {
                        click: function($event) {
                          return _vm.$emit("select-nav", item.id)
                        }
                      }
                    },
                    [
                      _c("icon-svg", {
                        staticClass: "flex-shrink-0",
                        attrs: {
                          name: item.iconName,
                          size: _vm.tamanhoIcone,
                          color: _vm.corIcone
                        }
                      }),
                      _c("span", { staticClass: "text-truncate" }, [
                        _vm._v(_vm._s(item.label))
                      ])
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.recolhida,
                  expression: "!recolhida"
                }
              ],
              class: {
                "chat-sidebar__painel-superior--personalizando":
                  _vm.modoPersonalizacao
              }
            },
            [
              _c(
                "transition",
                {
                  attrs: { name: "fade", mode: "out-in" },
                  on: { "after-enter": _vm.aoEntrarPainelNovo }
                },
                [
                  _vm.modoPersonalizacao
                    ? _c(
                        "div",
                        {
                          key: "personalizacao",
                          staticClass:
                            "chat-sidebar__insights chat-sidebar__personalizacao",
                          attrs: { "data-test": "personalizacao-painel" }
                        },
                        [
                          _c("PersonalizacaoCanvas", {
                            attrs: { itens: _vm.personalizacaoDraftVisiveis },
                            on: {
                              reordenar: _vm.aoReordenarRascunho,
                              remover: _vm.aoOcultarNoRascunho
                            }
                          })
                        ],
                        1
                      )
                    : _vm.temPainelDoCliente
                    ? _c(
                        "div",
                        {
                          key: "cliente",
                          staticClass:
                            "chat-sidebar__insights chat-sidebar__insights--cliente"
                        },
                        [
                          _c("IaClientePainel", {
                            attrs: {
                              cliente: _vm.clienteEmFoco,
                              ativos: _vm.dadosDoCliente.ativos,
                              serie: _vm.dadosDoCliente.serie,
                              variacao: _vm.dadosDoCliente.variacao,
                              "grupos-de-tarefa":
                                _vm.dadosDoCliente.gruposDeTarefa,
                              modo: _vm.dadosDoCliente.modo,
                              timeline: _vm.dadosDoCliente.timeline,
                              contratos: _vm.dadosDoCliente.contratos,
                              transcricoes: _vm.dadosDoCliente.transcricoes,
                              carregando: _vm.dadosDoCliente.carregando
                            },
                            on: {
                              "abrir-perfil": function($event) {
                                return _vm.$emit("abrir-perfil-cliente", $event)
                              },
                              "abrir-tarefas": function($event) {
                                return _vm.$emit(
                                  "abrir-tarefas-cliente",
                                  $event
                                )
                              },
                              "abrir-contatos": function($event) {
                                return _vm.$emit(
                                  "abrir-contatos-cliente",
                                  $event
                                )
                              },
                              "abrir-carteira": function($event) {
                                return _vm.$emit(
                                  "abrir-carteira-cliente",
                                  $event
                                )
                              },
                              "abrir-contratos": function($event) {
                                return _vm.$emit(
                                  "abrir-contratos-cliente",
                                  $event
                                )
                              },
                              "abrir-transcricoes": function($event) {
                                return _vm.$emit(
                                  "abrir-transcricoes-cliente",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm.mostraInsightsIndisponiveis
                    ? _c(
                        "div",
                        {
                          key: "insights-indisponiveis",
                          staticClass:
                            "chat-sidebar__insights chat-sidebar__aviso chat-sidebar__aviso--linha",
                          attrs: { "data-test": "insights-indisponiveis" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "chat-sidebar__aviso-texto" },
                            [
                              _c("div", { staticClass: "ia-sidebar-aux" }, [
                                _vm._v(_vm._s(_vm.texto.insightsIndisponiveis))
                              ]),
                              _c("div", { staticClass: "ia-sidebar-aux" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.texto.insightsIndisponiveisAjuda
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "chat-sidebar__aviso-retry",
                              attrs: {
                                icon: "",
                                small: "",
                                "aria-label": _vm.texto.tentarDeNovo,
                                title: _vm.texto.tentarDeNovo
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("recarregar-insights")
                                }
                              }
                            },
                            [
                              _c("icon-svg", {
                                attrs: {
                                  name: "refresh",
                                  size: 14,
                                  color: "var(--neutral-700)"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm.mostraInsightsVazio
                    ? _c(
                        "div",
                        {
                          key: "insights-vazio",
                          staticClass:
                            "chat-sidebar__insights chat-sidebar__aviso ia-sidebar-aux",
                          attrs: { "data-test": "insights-vazio" }
                        },
                        [_vm._v(" " + _vm._s(_vm.texto.insightsVazio) + " ")]
                      )
                    : _vm.temInsights
                    ? _c(
                        "div",
                        {
                          key: "modulos",
                          staticClass: "chat-sidebar__insights"
                        },
                        _vm._l(_vm.insights, function(linha) {
                          return _c(
                            "div",
                            {
                              key: linha.chave,
                              staticClass: "chat-sidebar__insight-linha",
                              class: {
                                "chat-sidebar__insight-linha--grade":
                                  linha.itens.length > 1,
                                "chat-sidebar__insight-linha--compacta":
                                  linha.compacta
                              },
                              style: { "--colunas": linha.colunas }
                            },
                            _vm._l(linha.itens, function(item) {
                              return _c(
                                "IaInsightCard",
                                _vm._b(
                                  {
                                    key: item.id,
                                    on: {
                                      abrir: function($event) {
                                        return _vm.$emit("abrir-insight", item)
                                      }
                                    }
                                  },
                                  "IaInsightCard",
                                  item,
                                  false
                                )
                              )
                            }),
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          !_vm.comoNavegacao
            ? _c(
                "button",
                {
                  staticClass: "ia-sidebar-row chat-sidebar__nova",
                  attrs: { type: "button", title: _vm.rotuloNovaConversa },
                  on: {
                    click: function($event) {
                      return _vm.$emit("new-conversation")
                    }
                  }
                },
                [
                  _c("icon-svg", {
                    staticClass: "flex-shrink-0",
                    attrs: {
                      name: "add-circle",
                      size: _vm.tamanhoIcone,
                      color: _vm.corIcone
                    }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.texto.novaConversa))])
                ],
                1
              )
            : _vm._e(),
          !_vm.comoNavegacao
            ? [
                _vm.recolhida
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "ia-sidebar-row chat-sidebar__buscar-compacta",
                        attrs: {
                          type: "button",
                          title: _vm.texto.buscaPlaceholder,
                          "aria-label": _vm.texto.buscaPlaceholder
                        },
                        on: { click: _vm.alternarRecolhida }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: "search",
                            size: _vm.tamanhoIcone,
                            color: _vm.corIcone
                          }
                        })
                      ],
                      1
                    )
                  : _c("input-by-type", {
                      staticClass: "ia-sidebar-busca my-2 mx-2",
                      attrs: {
                        type: "search",
                        "max-width": "100%",
                        clearable: "",
                        value: _vm.termoBusca,
                        placeholder: _vm.texto.buscaPlaceholder,
                        "aria-label": _vm.texto.buscaPlaceholder
                      },
                      on: { input: _vm.onBusca }
                    })
              ]
            : _vm._e(),
          _vm.movendo
            ? _c("v-progress-linear", {
                staticClass: "ia-sidebar-progresso",
                attrs: { indeterminate: "", height: "2" }
              })
            : _vm._e(),
          !_vm.modoPersonalizacao
            ? _c(
                "div",
                { staticClass: "chat-sidebar__secoes" },
                [
                  _vm.temAgentes && !_vm.comoNavegacao
                    ? _c(
                        "ChatSidebarGroup",
                        {
                          attrs: {
                            titulo: _vm.texto.secaoAgentes,
                            "icon-name": "ai-sparkle",
                            aberto: _vm.secoesAbertas.agentes
                          },
                          on: {
                            toggle: function($event) {
                              return _vm.alternarSecao(_vm.secoes.agentes)
                            }
                          }
                        },
                        _vm._l(_vm.itensAgentes, function(agente) {
                          return _c(
                            "button",
                            {
                              key: agente.id,
                              staticClass: "ia-sidebar-row",
                              class: { "ia-sidebar-row--ativo": agente.ativo },
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("select-agent", agente.id)
                                }
                              }
                            },
                            [
                              _c("icon-svg", {
                                staticClass: "flex-shrink-0",
                                attrs: {
                                  name: agente.iconName,
                                  size: _vm.tamanhoIcone,
                                  color: agente.corIcone
                                }
                              }),
                              _c("span", { staticClass: "text-truncate" }, [
                                _vm._v(_vm._s(agente.label))
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _c(
                    "ChatSidebarGroup",
                    {
                      ref: "secaoRecentes",
                      attrs: {
                        titulo: _vm.texto.secaoRecentes,
                        "icon-name": _vm.iconeDaSecaoRecentes,
                        contador: _vm.contadorDeRecentes,
                        aberto: _vm.secoesAbertas.recentes
                      },
                      on: {
                        toggle: function($event) {
                          return _vm.alternarSecao(_vm.secoes.recentes)
                        }
                      }
                    },
                    [
                      _vm.mostraCarregando
                        ? _c(
                            "div",
                            { staticClass: "chat-sidebar__esqueleto" },
                            [
                              _c("ChatSidebarEsqueleto", {
                                attrs: {
                                  quantidade: _vm.LINHAS_ESQUELETO_INICIAL,
                                  navegacao: _vm.comoNavegacao
                                }
                              })
                            ],
                            1
                          )
                        : _vm.mostraErro
                        ? _c(
                            "div",
                            { staticClass: "chat-sidebar__aviso" },
                            [
                              _c(
                                "div",
                                { staticClass: "ia-sidebar-aux mb-2" },
                                [_vm._v(_vm._s(_vm.texto.erro))]
                              ),
                              _c(
                                "BaseButton",
                                {
                                  attrs: {
                                    underlined: "",
                                    "min-width": "80px"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit("retry")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.texto.tentarDeNovo) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm.mostraVazio
                        ? _c(
                            "div",
                            {
                              staticClass: "ia-sidebar-aux chat-sidebar__aviso"
                            },
                            [_vm._v(" " + _vm._s(_vm.texto.vazio) + " ")]
                          )
                        : _vm.buscaSemResultado
                        ? _c(
                            "div",
                            {
                              staticClass: "ia-sidebar-aux chat-sidebar__aviso"
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.texto.buscaSemResultado) + " "
                              )
                            ]
                          )
                        : _c("ChatSidebarRecents", {
                            attrs: {
                              conversas: _vm.conversasFiltradas,
                              pastas: _vm.pastas,
                              agentes: _vm.agentes,
                              "selected-id": _vm.selectedId,
                              "estilo-limpo": _vm.comoNavegacao,
                              "permitir-selecao-lote": _vm.comoNavegacao,
                              "selected-ids": _vm.selectedIds
                            },
                            on: {
                              select: _vm.onSelect,
                              rename: _vm.onRename,
                              "request-delete": _vm.confirmDelete,
                              move: _vm.moverConversa,
                              "toggle-select": _vm.onToggleSelect
                            }
                          }),
                      _c(
                        "transition",
                        { attrs: { name: "chat-sidebar-fantasma" } },
                        [
                          _vm.mostraCargaDeMais
                            ? _c(
                                "div",
                                { staticClass: "chat-sidebar__mais" },
                                [
                                  _c("ChatSidebarEsqueleto", {
                                    attrs: {
                                      quantidade: _vm.LINHAS_FANTASMA,
                                      navegacao: ""
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  !_vm.comoNavegacao
                    ? _c(
                        "ChatSidebarGroup",
                        {
                          attrs: {
                            titulo: _vm.texto.secaoAgrupar,
                            "icon-name": "category",
                            aberto: _vm.secoesAbertas.agrupar
                          },
                          on: {
                            toggle: function($event) {
                              return _vm.alternarSecao(_vm.secoes.agrupar)
                            }
                          }
                        },
                        [
                          _c("ChatSidebarGroups", {
                            attrs: {
                              conversas: _vm.conversasFiltradas,
                              pastas: _vm.pastas,
                              agentes: _vm.agentes,
                              "contexto-listagem": _vm.eixoDosRecarregamentos,
                              "selected-id": _vm.selectedId,
                              carregando: _vm.carregando,
                              erro: _vm.erro
                            },
                            on: {
                              select: _vm.onSelect,
                              rename: _vm.onRename,
                              "request-delete": _vm.confirmDelete,
                              move: _vm.moverConversa,
                              retry: function($event) {
                                return _vm.$emit("retry")
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm.modoPersonalizacao
        ? _c("PersonalizacaoFooterActions", {
            attrs: {
              dirty: _vm.personalizacaoDirty,
              "loading-save": _vm.salvandoPersonalizacao,
              "sem-aviso": "",
              embutido: "",
              "cancelar-sem-edicao": ""
            },
            on: {
              cancel: _vm.aoCancelarPersonalizacao,
              save: _vm.aoSalvarPersonalizacao,
              reset: _vm.aoRestaurarPersonalizacaoPadrao
            }
          })
        : _vm.comoNavegacao
        ? _c("SaldoCreditosRodape", { attrs: { recolhida: _vm.recolhida } })
        : _vm._e(),
      _vm.comoNavegacao
        ? _c(
            "button",
            {
              staticClass: "chat-sidebar__retrair",
              attrs: {
                type: "button",
                title: _vm.tituloRecolher,
                "aria-label": _vm.tituloRecolher
              },
              on: { click: _vm.alternarRecolhida }
            },
            [
              _c("icon-svg", {
                attrs: {
                  name: _vm.iconeRecolher,
                  size: _vm.TAMANHO_ICONE_RETRAIR,
                  color: "var(--black)"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.selectedIds.length
        ? _c("AcoesLote", {
            attrs: {
              value: _vm.selectedIds,
              acoes: _vm.acoesLote,
              tipo: "conversas",
              "tipo-singular": "conversa",
              "select-text": "selecionadas",
              "select-text-singular": "selecionada"
            },
            on: { input: _vm.limparSelecaoLote }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }